export const getMortageData = (price: number, ratePercent: number, years: number = 30) => {
    const rate = ratePercent / 100;
    const value = Math.round((0.75 * price) / 100) * 100;
    const repayment = Math.round((value * (rate / 12)) / (1 - 1 / Math.pow(1 + rate / 12, years * 12)));

    return {
        repayment,
        rate,
    };
};
